import AppsIcon from '@mui/icons-material/Apps';
import { useXAAConfigurationStatus } from 'api/configurations';
import ConfigurationStatusCard from 'components/home/ConfigurationsStatus/ConfigurationStatusCards/ConfigurationStatusCard';
import DisabledModeTooltip from 'components/shared/DisabeldModeToolTip';
import { ROUTES } from 'constants/routes';
import { useIdPConfigContext } from 'contexts/IdPConfigContext';
import React, { useCallback } from 'react';
import { useNav } from 'utils/navigation';
import AddCta from './AddCta';
import ConfiguredMark from './ConfiguredMark';

// Cross-App Access (XAA / ID-JAG) is its own standalone config, alongside SSO and SCIM.
// Like the SSO/SCIM cards it routes THROUGH its own select page, which then enters the
// single trusted-issuer guide.
const XAAConfigurationStatusCard: React.FC = () => {
	const nav = useNav();
	const { isSubTenant } = useIdPConfigContext();

	const { data: xaaStatusData, isLoading } = useXAAConfigurationStatus();

	const handleClick = useCallback(() => {
		/* istanbul ignore if: no need to test this */
		if (isLoading || isSubTenant) {
			return;
		}

		nav(ROUTES.selectXaa);
	}, [isLoading, nav, isSubTenant]);

	return (
		<DisabledModeTooltip
			title={intl.tr('general.guide.disabledTooltip')}
			placement="right"
			disabled={isSubTenant}
		>
			<ConfigurationStatusCard
				idp={xaaStatusData?.idp}
				onClick={handleClick}
				disabled={isLoading || isSubTenant}
				icon={<AppsIcon fontSize="large" />}
				title={intl.tr('general.XAAConfiguration')}
				testIdTopic="xaa"
				footerContent={
					xaaStatusData?.xaaConfigured ? <ConfiguredMark /> : <AddCta />
				}
			/>
		</DisabledModeTooltip>
	);
};

export default XAAConfigurationStatusCard;
